{
  "063d16427da8d88a": "Usuario de la instalación",
  "09fd2948a8dffd21": "Lugar de trabajo",
  "0b9e49cf035bd75b": "Entrevistas",
  "12bd656f89dac984": "De: {{phone}}",
  "1449d5fb47172cac": "Copiar correo electrónico",
  "18c938b5aab50b5e": "Selecciona una conversación para ver los mensajes",
  "198070bbff07ba8e": "Buscar por teléfono, nombre o lugar de trabajo...",
  "1e380e06fb20ef9f": "No se encontraron usuarios de la instalación",
  "203a908d5a59c019": "Recibir mensaje de prueba",
  "25b345c161d37ee1": "Error al enviar el mensaje. Por favor, inténtalo de nuevo.",
  "27c2ccd962c2b8dc": "Error desconocido",
  "286a3af7348e8312": "Enviando...",
  "347130fa83e4cbe9": "Entrevistas pasadas",
  "41a39ca90a9915d7": "Error al enviar SMS de prueba: {{message}}",
  "41a634bed37381ba": "Ver perfil",
  "47d2a515ef2f05b8": "Cargando...",
  "50b5ff647ec2fb07": "Respuesta de SMS de entrada de prueba",
  "53b41938bd3d3231": "Buscar un usuario de la instalación por nombre, teléfono o lugar de trabajo",
  "604bf413faba50fa": "SMS de prueba enviado - verifica #knock-sms-replies-dev",
  "7136799df2d343e1": "Cuerpo del mensaje",
  "7d9eb7acb13e2462": "Cerrar",
  "7e8cd2056da73a7f": "Título",
  "7f1a9822a78ca8f0": "Solicitado para {{role}}",
  "8751245b0ffb8022": "Ver trabajador",
  "8cb80a46a50f59e4": "No hay más mensajes",
  "8d849d37ac0b8b55": "Usuario del lugar de trabajo",
  "8f8c8c8142bc3bce": "Copiar ID del lugar de trabajo",
  "92907d8c70891118": "Error al cargar el perfil",
  "93a26b1eaff99b3a": "Enviar mensaje",
  "942087cc2d41e013": "Reintentar",
  "969ccbd3cf6300ec": "Correo electrónico",
  "ac8991ef01019cf5": "Cargar más",
  "ae55fc046c4cf3ae": "Error al cargar las conversaciones",
  "c21e016f5b62c9fb": "Aún no hay mensajes. Envía el primer mensaje a continuación.",
  "c455e88bc6a74f2f": "Copiar ID del trabajador",
  "c7677b97318f448a": "Portal de SMS",
  "ca70b50942518156": "Ops",
  "dcd1d5223f73b3a9": "Nombre",
  "e7887dce6f9ebb97": "Ver entrevista",
  "e9bddf7360b6dc62": "Escribe tu mensaje...",
  "eeaaa7b4d5d7f090": "Error al cargar los mensajes",
  "f0743d83f900e797": "Dispara el flujo de hilo de respuesta de SMS en Slack exactamente como lo haría un SMS entrante real. Publica en #knock-sms-replies-dev. Múltiples envíos se agrupan dentro de la ventana controlada por LD.",
  "f17671d83db0da48": "Cargar mensajes antiguos",
  "f4486f0e1296fbd9": "Entrevistas próximas",
  "f6f4688ff23d50c6": "Enviar"
}
